"use client"

import Script from "next/script";

export default function GoogleTagManager() {
    return (
        <>
            <Script
                async
                src="https://www.googletagmanager.com/gtag/js?id=GTM-W354WVDC"
            />
            <Script id="gtm-init" strategy="afterInteractive">
                {`
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date());
                    gtag('config', 'GTM-W354WVDC');
                `}
            </Script>
        </>
    );
}
